import React from 'react';
import ProductCard from '../Components/Products/ProductCard';

const ProductList = ({ products }) => {
  return (
    <div className="py-4">
      <h1 className="text-3xl md:text-4xl font-semibold tracking-wider text-primary-300 subpixel-antialiased mb-6">
            Oyoyo Products
          </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default ProductList;
